import { Component, ViewChild, OnInit } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { ToastController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';

/**
 * LoadAllIonicComponent
 * 
 * This component is only rendered in development mode to help load all necessary Ionic components
 * upfront, ensuring that everything is initialized and ready for interaction. It preloads Ionic UI
 * elements like modals and toasts by rendering them offscreen to avoid delays during actual use.
 * 
 * Dependencies:
 * - ToastController: To create and display toast messages.
 * - IonModal: Preloads the modal component.
 * 
 * Behavior:
 * - On initialization, this component displays a toast message to trigger the loading of Ionic components.
 * - The modal is pre-loaded offscreen but can be interacted with if needed.
 */



@Component({
  selector: 'app-load-all-ionic',
  templateUrl: './load-all-ionic.component.html',
  styleUrls: ['./load-all-ionic.component.css'],
})
export class LoadAllIonicComponent  implements OnInit {
  private _toastController: ToastController;
  private _alertController: AlertController;
  private _actionSheetController: ActionSheetController;

  @ViewChild(IonModal) modal!: IonModal;

  message = 'This modal example uses triggers to automatically open a modal when the button is clicked.';
  name!: string;



  constructor(
    toastController: ToastController,
    alertController: AlertController,
    actionSheetController: ActionSheetController,
  ){
    this._toastController = toastController;
    this._alertController = alertController;
    this._actionSheetController = actionSheetController;
  }

  async ngOnInit(): Promise<void> {
    this.openToast();
    const alert = await this._alertController.create({
      header: 'Alert',
      message: 'This is an alert',
      buttons: ['OK']
    });
    alert.present();

    this.openActionSheet();

  }


  async openToast() {
    const toast = await this._toastController.create({
      message: 'This is a test toast (dev mode only)',
      cssClass: 'toast-invisible',
      duration: 2000,
    });
    await toast.present();

  }

  /**
   * Preloads the ion-action-sheet overlay (dev mode only), the same way openToast
   * bootstraps the toast: create + present it invisibly, then immediately dismiss.
   * The card kebab menu (TableComponent) uses ActionSheetController, which needs
   * the overlay component registered up front.
   */
  async openActionSheet() {
    const actionSheet = await this._actionSheetController.create({
      header: 'Preload (dev mode only)',
      cssClass: 'action-sheet-invisible',
      buttons: [{ text: 'Cancel', role: 'cancel' }],
    });
    await actionSheet.present();
    await actionSheet.dismiss();

  }


  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  confirm() {
    this.modal.dismiss(this.name, 'confirm');
  }

  onWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
      this.message = `Hello, ${ev.detail.data}!`;
    }
  }

}
